import { Buffer } from 'buffer';
import moment from 'moment';
import { TenantTsType } from '../constants/tenantTs';

const DEFAULT_DP_LINK_DATE_FORMAT = 'DD/MM/YYYY';

/** Decode base64 flight bundle identifier (best-effort). */
export const decodeFlightIdentifierPayload = (
  identifier?: string
): Record<string, unknown> | null => {
  if (!identifier) return null;
  try {
    return JSON.parse(
      Buffer.from(identifier, 'base64').toString('utf8')
    ) as Record<string, unknown>;
  } catch {
    return null;
  }
};

/** Map embedded flight dates to B2C search URL date strings (DD/MM/YYYY). */
export const getSearchDatesFromFlightIdentifier = (
  identifier?: string,
  dateFormat = DEFAULT_DP_LINK_DATE_FORMAT
): { from?: string; to?: string } => {
  const decoded = decodeFlightIdentifierPayload(identifier);
  if (!decoded) return {};
  const fromRaw = decoded.from_date ?? decoded.from;
  const toRaw = decoded.return_date ?? decoded.to_date ?? decoded.to;
  if (!fromRaw || !toRaw) return {};
  const fromMoment = moment(fromRaw as string);
  const toMoment = moment(toRaw as string);
  return {
    from: fromMoment.isValid()
      ? fromMoment.format(dateFormat)
      : String(fromRaw),
    to: toMoment.isValid() ? toMoment.format(dateFormat) : String(toRaw),
  };
};

export const getTsTypeByIdentifier = ({
  identifier,
  type,
}: {
  identifier?: string;
  type?: 'flight' | 'hotel';
}): TenantTsType | undefined => {
  if (!identifier) return undefined;
  const decoded = decodeFlightIdentifierPayload(identifier);
  if (!decoded) return undefined;
  const tsString = String(decoded?.ts);
  return (Object.values(TenantTsType) as string[]).includes(tsString)
    ? (tsString as TenantTsType)
    : undefined;
};
